import { Component, Input, OnInit } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { InboundFaxInfoComponent } from '../inbound-fax-info/inbound-fax-info.component';
import { PhoneNumberPipe } from '../../../shared/pipes/phone-number.pipe';

@Component({
    selector: 'app-inbound-fax-header',
    templateUrl: './inbound-fax-header.component.html',
    styleUrls: ['./inbound-fax-header.component.scss'],
    imports: [FaIconComponent, PhoneNumberComponent, CopyToClipboardComponent, InboundFaxInfoComponent, PhoneNumberPipe]
})
export class InboundFaxHeaderComponent implements OnInit {
  @Input() inboundFax: InboundFax;

  constructor() {}

  ngOnInit() {}
}
